<script>
  // A counted breakdown with bars: one row per group, its count, and its share
  // of the block total. Used by the Comparison panels (one value column) and by
  // the Catalog cube drill-down (one column per dimension the cube carries) —
  // the same numbers in both places, so the same table.
  //
  // Rows arrive already filtered and aggregated; this component decides nothing
  // about which rows to show, only how they read. `total` is the denominator
  // the caller wants the percentages against, which is not always the sum of
  // the rows shown.
  let { columns = [], rows = [], total = 0 } = $props();

  // The longest bar is the largest count present, not the total — a marginal
  // where one value dominates would otherwise render every other bar invisible.
  const max = $derived(Math.max(1, ...rows.map((r) => r.count)));
  const pct = (n) => (total ? ((n / total) * 100).toFixed(1) + '%' : '—');
</script>

<div class="wf2-tablewrap" style="overflow-x:auto">
  <table class="wf2-table">
    <thead>
      <tr>
        {#each columns as c}<th class="mono">{c}</th>{/each}
        <th>Count</th>
        <th style="width:35%">Share</th>
      </tr>
    </thead>
    <tbody>
      {#each rows as r}
        <tr>
          {#each r.values as v, i}
            <!-- A labelled value (a concept of the term's scheme) carries its
                 code on hover; an unlabelled one is the code itself. -->
            {#if r.codes?.[i]}<td title={r.codes[i]}>{v}</td>{:else}<td class="mono">{v ?? '—'}</td>{/if}
          {/each}
          <td>{r.count}</td>
          <td>
            <div class="bar-track"><div class="bar" style="width:{(r.count / max) * 100}%"></div></div>
            <span class="wf2-caption">{pct(r.count)}</span>
          </td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
